import { FlowFilterMatchRule, FlowFilterOperation } from 'flow-schema';

export const FILTER_BLOCK_OPERATION_NAMES: Record<FlowFilterOperation, string> = {
  [FlowFilterOperation.Equals]: 'equals',
  [FlowFilterOperation.NotEquals]: 'does not equal',
  [FlowFilterOperation.Contains]: 'contains',
  [FlowFilterOperation.DoesNotContain]: 'does not contain',
  [FlowFilterOperation.GreaterThan]: 'is greater than',
  [FlowFilterOperation.GreaterThanOrEqualTo]: 'is greater than or equal to',
  [FlowFilterOperation.LessThan]: 'is less than',
  [FlowFilterOperation.LessThanOrEqualTo]: 'is less than or equal to',
  [FlowFilterOperation.IsOneOf]: 'is one of',
  [FlowFilterOperation.IsNotOneOf]: 'is not one of',
  [FlowFilterOperation.StartsWith]: 'starts with',
  [FlowFilterOperation.EndsWith]: 'ends with',
  [FlowFilterOperation.IsNull]: 'is null',
  [FlowFilterOperation.IsNotNull]: 'is not null',
};

export const FILTER_BLOCK_MATCH_RULE_NAMES: Record<FlowFilterMatchRule, string> = {
  [FlowFilterMatchRule.All]: 'all',
  [FlowFilterMatchRule.Any]: 'any',
};

export const FILTER_BLOCK_NULL_OPERATIONS = new Set([
  FlowFilterOperation.IsNull,
  FlowFilterOperation.IsNotNull,
]);
